angular.module('salesPath2')
  .directive('nonEtxModel', ['availabilityHelper', 'dictionaryServiceHelper',
    function(availabilityHelper, dictionaryServiceHelper) {
      return {
        restrict: 'E',
        replace: true,
        scope: true,
        templateUrl: function(elem, attrs) {
          if (attrs.drvTemplate) {
            return attrs.drvTemplate;
          } else if (availabilityHelper.isAvailable('nonEtxModel')) {
            return 'salesPath2Template/autocompleters/vehicle/nonEtxModel/nonEtxModel.tpl.html';
          } else {
            return 'salesPath2Template/autocompleters/vehicle/nonEtxModel/nonEtxModelWithoutDict.tpl.html';
          }
        },
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {

          $scope.$watch($attrs.errors, function(val) {

            if (!val || !val.vehicleModel) {
              $scope.hasError = false;
            } else {
              $scope.hasError = !!val.vehicleModel;
              $scope.invalidText = val.vehicleModel.message;
            }

          });

          if (availabilityHelper.isAvailable('nonEtxModel')) {
            $scope.getVehicleModel = function(query) {
              $scope.loadingElements = true;
              var obj = [];

              return dictionaryServiceHelper.getVehicleModelsService().find({
                ProductCode: 'H1H7V_OBJECT_VEHICLE',
                registrationTypeCode: $scope.modalData.formData.dependencySelects.category[1],
                markCode: $scope.modalData.formData.dependencySelects.mark[1] ? $scope.modalData.formData.dependencySelects.mark[1] : 'internal',
                value: query
              }).then(function(res) {
                if (angular.isUndefined(res) || angular.isUndefined(res.data) || angular.isUndefined(res.data.items)) {
                  obj = [];
                } else {
                  $scope.loadingElements = false;
                  if (angular.isDefined(res)) {
                    angular.forEach(res.data.items, function(item) {
                      obj.push(item);
                    });
                  }
                }
                return obj;
              }, angular.noop);
            };
          }
        }]
      };
    }
  ]);